<template>
  <!-- Welcome screen -->
  <div class="login-wrap welcome-screen">
    <!-- Content (top part) -->
    <div class="login-content">
      <!-- MP logo -->
      <img
        src="../assets/images/login/logo-mp-white.svg"
        alt="MeetPoint"
        class="welcome-logo"
      />

      <!-- App name -->
      <div class="welcome-title">SCAN APP</div>

      <!-- Login btn -->
      <button
        @click="goToLogin"
        class="btn btn--lg btn--primary-inverted welcome-btn"
      >
        Log in
      </button>
    </div>

    <!-- Footer (bottom part) -->
    <footer class="login-footer">
      MP Scan app is part of the MeetPoint family of event management
      solutions. <br />
      Use your MeetPoint credentials to log in or contact us at
      <a href="mailto:support@meetpoint.si" target="_blank">support@meetpoint.si</a> for more
      information.
    </footer>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  methods: {
    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>
